import { createContext, useContext } from "react";

import { QuantityButtonsContextType } from "../types";

export const QuantityButtonsContext = createContext<QuantityButtonsContextType>(
  undefined as unknown as QuantityButtonsContextType
);

export const useQuantityButtonsContext = () =>
  useContext(QuantityButtonsContext);
